import React from 'react';
import styles from './Footer.module.less';
import { FooterCopyright } from './parts/FooterCopyright';
import SocialIcons from './parts/SocialIcons';
import useMobile from "../../hooks/useMobile";

const FooterAskTerra = () => {
  const isMobile = useMobile(798);

  return (
    <footer className={`${styles.footer} ${styles.footerTerra}`}>
      <div className={styles.container1170}>
        <div className={styles.footerContacts}>
          <div className={`${styles.footerContactsBlock}`}>
            <a
              data-test-id="supportCenter"
              target="_blank"
              rel="noreferrer"
              href="https://insidetracker-faq.gorgias.help/"
              className={styles.footerTitle}
            >
              Support center
            </a>
            {' '}
            <span className={styles.divider}>|</span>
            {' '}
            <a
              data-test-id="contactus"
              href="https://insidetracker-faq.gorgias.help/en-US/how-can-i-contact-you-288947"
              className={styles.footerTitle}
              target="_blank"
              rel="noreferrer"
            >
              Contact us
            </a>
          </div>
          <SocialIcons/>
        </div>
        {!isMobile && (
        <FooterCopyright/>
        )}
      </div>
    </footer>
  );
};

export default FooterAskTerra;
